import { render } from "./PointUsedCar.vue?vue&type=template&id=2c6b3d2a&scoped=true"
import script from "./PointUsedCar.vue?vue&type=script&lang=js"
export * from "./PointUsedCar.vue?vue&type=script&lang=js"

import "./PointUsedCar.vue?vue&type=style&index=0&id=2c6b3d2a&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c6b3d2a"]])

export default __exports__